module.exports = __webpack_public_path__ + "img/grab.442db5db.jpg";